import React, { Component } from "react";
import logErroService from "../../services/Admin/LogErroService";

/**
 * ErrorBoundary global (Tarefa-19336). Captura erros que escapam dos componentes
 * filhos durante o render/lifecycle e reporta para o backend em /admin/log-erro/frontend.
 *
 * Também instala listeners de window.error e unhandledrejection para cobrir
 * promises não tratadas e erros assíncronos que o ErrorBoundary do React não pega.
 */
class GlobalErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidMount() {
    window.addEventListener("error", this.handleWindowError);
    window.addEventListener("unhandledrejection", this.handleUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener("error", this.handleWindowError);
    window.removeEventListener("unhandledrejection", this.handleUnhandledRejection);
  }

  componentDidCatch(error, info) {
    logErroService.reportarErroFrontend({
      mensagem: this.recortar(error?.message || String(error), 1000),
      stacktrace: this.recortar((error?.stack || "") + "\n\nComponentStack:" + (info?.componentStack || ""), 2000),
      endpoint: this.localizacaoAtual(),
      origem: "ErrorBoundary",
    });
  }

  handleWindowError = (event) => {
    if (!event || !event.error) return;
    logErroService.reportarErroFrontend({
      mensagem: this.recortar(event.message || String(event.error), 1000),
      stacktrace: this.recortar(event.error?.stack || "", 2000),
      endpoint: this.localizacaoAtual(),
      origem: "window.onerror",
    });
  };

  handleUnhandledRejection = (event) => {
    const reason = event?.reason;
    const mensagem = (reason && reason.message) || String(reason);
    const stack = (reason && reason.stack) || "";
    logErroService.reportarErroFrontend({
      mensagem: this.recortar(mensagem, 1000),
      stacktrace: this.recortar(stack, 2000),
      endpoint: this.localizacaoAtual(),
      origem: "unhandledrejection",
    });
  };

  localizacaoAtual() {
    try {
      return window.location?.pathname + (window.location?.hash || "");
    } catch (e) {
      return "";
    }
  }

  recortar(s, max) {
    if (!s) return s;
    return s.length <= max ? s : s.substring(0, max);
  }

  resetar = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          maxWidth: 520,
          margin: "10vh auto",
          padding: 24,
          background: "#fef2f2",
          border: "1px solid #fecaca",
          borderRadius: 12,
          textAlign: "center",
        }}>
          <h3 style={{ color: "#b91c1c", marginBottom: 12 }}>Ocorreu um erro inesperado</h3>
          <p style={{ color: "#7f1d1d", marginBottom: 20 }}>
            O erro foi registrado. Você pode tentar voltar ou recarregar a página.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 16px",
              background: "#dc2626",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontWeight: 600,
            }}>
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
